import React from 'react'
import PropTypes from 'prop-types'
import { MessagesListItem } from './style'
import { CommonMessage } from './messages/CommonMessage'
import { RepliedMessage } from './messages/RepliedMessage'

export const ChatMessage = React.memo(function ChatMessage({
  isDesktop,
  getModeratorColorByUsername,
  user,
  message,
}) {
  const showMessage = message.type !== 'deleted' || message.user.id === user.id

  const renderMessage = (message) => {
    if (message.type === 'reply')
      return (
        <RepliedMessage
          message={message}
          getModeratorColorByUsername={getModeratorColorByUsername}
          isDesktop={isDesktop}
        />
      )

    return (
      <CommonMessage
        message={message}
        getModeratorColorByUsername={getModeratorColorByUsername}
        isDesktop={isDesktop}
      />
    )
  }

  return <>{showMessage ? <MessagesListItem>{renderMessage(message)}</MessagesListItem> : null}</>
})

ChatMessage.propTypes = {
  isDesktop: PropTypes.bool,
  user: PropTypes.object.isRequired,
  message: PropTypes.object,
  getModeratorColorByUsername: PropTypes.func,
}
